import React, { useMemo, useState } from "react";
import LedgerTable from "./LedgerTable";
import "../../../../../css/pages/ca_pages/finances/models/books_ledgers_model/LedgerWorkspace.css";

const LedgerWorkspace = ({ ledgers = [] }) => {
    const [search, setSearch] = useState("");
    const [statusFilter, setStatusFilter] = useState("all");
    const [typeFilter, setTypeFilter] = useState("all");

    const filteredLedgers = useMemo(() => {
        return ledgers.filter((ledger) => {
            const query = search.trim().toLowerCase();

            const matchesSearch =
                !query ||
                ledger.name?.toLowerCase().includes(query) ||
                ledger.code?.toLowerCase().includes(query) ||
                ledger.group_name?.toLowerCase().includes(query);

            const matchesStatus =
                statusFilter === "all" ||
                (statusFilter === "active"
                ? ledger.is_active !== false
                : ledger.is_active === false);

            const matchesType = typeFilter === "all" || ledger.ledger_type === typeFilter;

            return matchesSearch && matchesStatus && matchesType;
        });
    }, [ledgers, search, statusFilter, typeFilter]);

    const customerCount = ledgers.filter(
        (ledger) => ledger.ledger_type === "customer",
    ).length;

    const systemCount = ledgers.filter((ledger) => ledger.is_system).length;

    return (
        <section className="ledger-workspace">
            <div className="workspace-header">
                <div>
                    <span className="workspace-eyebrow">ACCOUNTING STRUCTURE</span>

                    <h3>Ledgers</h3>

                    <p>
                        Accounts used to record and track this business's financial activity.
                    </p>
                </div>

                <div className="workspace-summary">
                    <strong>{filteredLedgers.length}</strong>

                    <span>of {ledgers.length} ledgers</span>
                </div>
            </div>

            <div className="ledger-insights">
                <div>
                    <strong>{ledgers.length}</strong>
                    <span>Total ledgers</span>
                </div>

                <div>
                    <strong>{customerCount}</strong>
                    <span>Customer accounts</span>
                </div>

                <div>
                    <strong>{systemCount}</strong>
                    <span>System ledgers</span>
                </div>
            </div>

            <div className="ledger-toolbar">
                <div className="ledger-search">
                    <span>⌕</span>

                    <input
                        type="text"
                        placeholder="Search ledger, code or group..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>

                <select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                >
                    <option value="all">All statuses</option>

                    <option value="active">Active</option>

                    <option value="inactive">Inactive</option>
                </select>

                <select
                    value={typeFilter}
                    onChange={(e) => setTypeFilter(e.target.value)}
                >
                    <option value="all">All types</option>

                    <option value="customer">Customer</option>

                    <option value="system">System</option>
                </select>
            </div>

            <LedgerTable ledgers={filteredLedgers} />
        </section>
    );
};

export default LedgerWorkspace;
